import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import { validateTextArea, onPasteSanitize } from '../../js/summernote_utils';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'diplomasTextarea',
    ];

    openModal(data) {
        $(this.diplomasTextareaTarget).summernote({
            toolbar: [
                ['style', ['bold', 'italic']],
                ['para', ['ul', 'ol']],
                ['toggleEditor'],
            ],
            tooltip: false,
            disableResizeEditor: true,
            placeholder: translations['profile.Diplomas placeholder'],
            callbacks: {
                onPaste: onPasteSanitize,
            },
        });

        if (data.trim().length > 0) {
            $(this.diplomasTextareaTarget).summernote('code', data);
        }

        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });
    }

    save() {
        showPreloader();
        const cleanedDescription = validateTextArea($(this.diplomasTextareaTarget).parent().find('.note-editable'));

        $.ajax({
            url: routes['app_profile_diplomasfieldupdate'],
            data: { description: cleanedDescription },
            success: (response) => {
                if (response.status) {
                    $(this.element).modal('hide');

                    // Change old diplomas with the correct transform of the text
                    $('#diplomas-textarea-readonly').parent().find('.note-editable').html(response.diplomas);
                    $('#diplomas-textarea-readonly').html(response.diplomas);

                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            'category': 'Account',
                            'action': 'diplomas | Success',
                            'label': GA_EVENT_LABEL,
                        },
                    });

                    window.location.reload();
                } else {
                    hidePreloader();
                    addAlert('danger', response.message ?? translations['profile.An unknown error occurred.']);
                }
            },
            error: function(error) {
                hidePreloader();
                const json = error.responseJSON;

                if (json && json.message) {
                    addAlert('danger', json.message);
                    return;
                }

                addAlert('danger', translations['profile.An unknown error occurred.']);
            },
        });
    }
}
